/*
 * Copyright (c) 2023. Bolmate B.V.
 */

import {updateInvoiceRequestCount} from "./events";

let openCount = -1;

export function setOpenInvoiceRequestCount(count: number) {
    if (count < 0)
        count = openCount - 1;
    openCount = count;
    updateInvoiceRequestCount(openCount);
}

export function getOpenInvoiceRequestCount(): number {
    return openCount;
}